import React from 'react';
import Grid from '@material-ui/core/Grid';
import Container from '../../components/dashboard/container';
import { isCoordinator } from '../../components/access';
import { withAuthorization } from '../../model/Session';
import ClientForm from './clientForm';
import * as ROUTES from '../../constants/routes';

const NewClient = () => (
  <Container backPath={ROUTES.CLIENTES} title="Nuevo Cliente">
    <Grid container spacing={3} justify="center">
      <Grid item xs={12} md={6}>
        <ClientForm />
      </Grid>
    </Grid>
  </Container>
);

export default withAuthorization(isCoordinator)(NewClient);
